'use strict';

const blzEvent = require('./blz-event');
const util = require('./blz-tracking-util');
const Smartbanner = require('../../components/smartbanner');
const is = require('../is');
const abTestEngine = require('@belezanaweb/ab-test');

const ONE_WEEK = 1000 * 60 * 60 * 24 * 7;

const EventTracking = {
  entrance: function () {
    const userIdentity = util.readCookie('userIdentity');
    if (!userIdentity) {
      const ONE_YEAR = 365 * 24 * 60 * 60 * 1000;
      document.cookie = util.setCookie('userIdentity', util.guid(), ONE_YEAR);
    }

    const firstSession = util.readCookie('blzSessionId');
    const blzSessionId = util.readCookie('blzSessionId') || util.guid();
    document.cookie = util.setCookie('blzSessionId', blzSessionId);

    blzEvent.entrance(firstSession);
  },

  search: function (data) {
    if (!data) return false;
    blzEvent.search(data);
  },

  productClick: function (data) {
    if (!data) return false;
    blzEvent.productClick(data);
  },

  pageView: function (data) {
    if (!data) return false;

    if (!blz.pageName || /account/.test(blz.pageName)) return false;

    blzEvent.pageView(data);
  },

  bannerView: function () {
    try {
      const bannersViewedJSON = JSON.parse(util.readCookie('bannersViewed'));

      if (bannersViewedJSON && bannersViewedJSON.bannersViewed) {
        blzEvent.bannerView(bannersViewedJSON.bannersViewed, bannersViewedJSON.uri);
        document.cookie = util.setCookie('bannersViewed', null);
      }
    } catch (o_O) {
      //
    }
  },

  boxPhysicalStoreView: function () {
    if ($('.box-physical-store').length) {
      blzEvent.interaction(
        {},
        {
          category: (blz.pageName || '').toUpperCase(),
          action: 'Box-Physical-Store'
        }
      );
    }
  },

  blzAbTest: function (tests) {
    if ((blz.globals.email || '').indexOf('@belezanaweb.com.br') > -1) {
      abTestEngine.init(tests);
    }
  },

  bannerClick: blzEvent.bannerClick,
  FBinfo: blzEvent.fbinfo,
  fbinfo: blzEvent.fbinfo,
  interaction: blzEvent.interaction
};

if (/belezanaweb/.test(document.domain) || /belezanaweb/.test(location.hostname)) {
  const abTests = [
    //
  ];

  abTestEngine.init(abTests);
}

$(document).on('cart:add-product', function (_event, cartItem) {
  blzEvent.addProduct(cartItem);
});

$(document).on('cart:create', function (event) {
  blzEvent.interaction(event, {
    category: (blz.pageName || '').toUpperCase(),
    action: 'Cart-Create'
  });
});

$(document).on('click tap', '[data-banner]', blzEvent.bannerClick);
$(document).on('click tap', '[data-interaction]', blzEvent.interaction);
$(document).on('shopping-bag:select-click', function (event, data) {
  blzEvent.interaction(event, data);
});

$(document).on('click tap', '.smartbanner-download', function (event) {
  event.preventDefault();
  location.href = is.iphone()
    ? 'https://itunes.apple.com/br/app/beleza-na-web/id1137374669?mt=8'
    : 'https://play.google.com/store/apps/details?id=br.com.belezanaweb.android';
});

$(document).on('click tap', '.smartbanner-download, .smartbanner-exit', function (event) {
  const platform = is.iphone() ? 'ios' : 'android';
  blzEvent.smartbanner(event, platform);
  document.cookie = util.setCookie('smartbanner-exited', '1', ONE_WEEK);
  Smartbanner.hide();
});

/* first set abTest cookie before fire events */
EventTracking.entrance();
EventTracking.pageView({
  name: document.title,
  showcaseProperties: blz.globals.showcaseProperties
});
EventTracking.bannerView();
EventTracking.boxPhysicalStoreView();

module.exports = EventTracking;
